import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import InvoiceList from '../components/invoices/InvoiceList';
import InvoiceForm from '../components/invoices/InvoiceForm';
import InvoiceDetail from '../components/invoices/InvoiceDetail';
import InvoicePreview from '../components/invoices/InvoicePreview'; // Nouveau composant

const InvoiceManagement = () => {
    const [view, setView] = useState('list');
    const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [showPreview, setShowPreview] = useState(false); // Nouvel état pour l'aperçu PDF

    // Information de l'entreprise (à déplacer vers un fichier de configuration ou context)
    const companyInfo = {
        name: ' SEN OSCAR',
        address: {
            street: '123 Rue Thiés',
            postalCode: '75000',
            city: 'Thiés, Dakar',
            country: 'Sénégal'
        },
        // vatNumber: 'FR12345678900',
        siret: ' +221 33 888 88 88',
        phone: '+33 1 23 45 67 89',
        // email: 'contact@votreentreprise.com',
        // bankDetails: {
        //     iban: 'FR76 1234 5678 9012 3456 7890 123',
        //     bic: 'ABCDEFGHIJK',
        //     bankName: 'Banque Example'
        // }
    };

    const handleCreateInvoice = () => {
        setSelectedInvoiceId(null);
        setView('form');
    };

    const handleViewInvoice = (invoiceId, edit = false) => {
        setSelectedInvoiceId(invoiceId);
        setEditMode(edit);
        setView('detail');
    };

    const handleCancel = () => {
        setView('list');
        setSelectedInvoiceId(null);
        setEditMode(false);
    };

    const handleSuccess = () => {
        setView('list');
        setSelectedInvoiceId(null);
        setEditMode(false);
    };

    // Nouvelle méthode pour ouvrir l'aperçu PDF
    const handleOpenPdfPreview = (invoiceId) => {
        setSelectedInvoiceId(invoiceId);
        setShowPreview(true);
    };

    const handleEditInvoice = () => {
        setEditMode(true);
        setView('detail');
    };
    

    return (
        <Container fluid>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h1 className="h3">Gestion de la facturation</h1>
            </div>

            {view === 'list' && (
                <InvoiceList
                    onViewInvoice={handleViewInvoice}
                    onCreateInvoice={handleCreateInvoice}
                    onPreviewInvoice={handleOpenPdfPreview} // Nouvelle prop
                    companyInfo={companyInfo} // Passer les infos de l'entreprise
                />
            )}

            {view === 'form' && (
                <InvoiceForm
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                />
            )}

            {view === 'detail' && (
                <InvoiceDetail
                    invoiceId={selectedInvoiceId}
                    editMode={editMode}
                    onEdit={handleEditInvoice} // <-- ajout ici
                    onCancel={handleCancel}
                    onSuccess={handleSuccess}
                    onPreviewPdf={handleOpenPdfPreview} // Nouvelle prop pour accéder à l'aperçu PDF depuis le détail
                />
            )}

            {/* Modal de prévisualisation PDF */}
            <InvoicePreview 
                invoiceId={selectedInvoiceId}
                show={showPreview}
                onHide={() => setShowPreview(false)}
                companyInfo={companyInfo}
            />
        </Container>
    );
};

export default InvoiceManagement;